import React from 'react'
import { Redirect } from 'react-router-dom'

import { authorization } from 'Module/Auth/Auth'
import { NotAuthorised } from 'Components/Page'

export function PrivateRoute({ children, ...rest }) {
  if (!rest.isRestricted && authorization.isLogged()) {
    return children
  }

  return <Redirect to={'/login'} />
}

export function AdminRoute({ children, ...rest }) {
  if (authorization.isAdmin()) {
    return children
  }

  return <NotAuthorised {...rest} />
}

export function CityManagerRoute({ children, ...rest }) {
  if (authorization.isAdmin() || authorization.isCityManager()) {
    return children
  }

  return <NotAuthorised {...rest} />
}

export function ClientAdminRoute({ children, ...rest }) {
  if (authorization.isAdmin() || authorization.isClientAdmin()) {
    return children
  }

  return <NotAuthorised {...rest} />
}

export function NotSpyRoute({ children, ...rest }) {
  if (authorization.isSpy()) {
    return <NotAuthorised {...rest} />
  }

  return children
}



// WEBPACK FOOTER //
// ./src/Config/Routing/auth/index.js